import { ReactNode } from 'react'
import { Modal } from 'react-bootstrap'
import ReactDOM from 'react-dom'
import ModalHeader from './ModalHeader'

type IAppModal = {
  title?: string | ReactNode
  noHeader?: boolean
  children: string | JSX.Element | any
  isOpen: boolean
  handleClose?: () => void
  size?: 'sm' | 'md' | 'lg' | 'xl'
  holdOn?: boolean
}

const modalsRoot = document.getElementById('root-modals') || document.body

const AppModal = ({
  title,
  noHeader,
  children,
  holdOn,
  isOpen,
  handleClose,
  size = 'sm',
}: IAppModal) => {
  if (!isOpen) return null

  // react-bootstrap's `size` only supports sm|lg|xl (its default width IS medium),
  // so emit `modal-md` via the dialog class instead of the unsupported size prop.
  const bsSize = size === 'md' ? undefined : size
  const dialogClassName = `modal-dialog modal-dialog-centered${size === 'md' ? ' modal-md' : ''}`

  return ReactDOM.createPortal(
    <Modal
      contentClassName='erp-modal'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName={dialogClassName}
      show={isOpen}
      onHide={handleClose}
      backdrop={holdOn ? 'static' : true}
      size={bsSize}
    >
      {!noHeader && <ModalHeader title={title} handleClose={handleClose} />}
      {children}
    </Modal>,
    modalsRoot
  )
}
export default AppModal
